module.exports = __webpack_public_path__ + "static/img/14000129.e3de566a.png";